import { Outlet, useMatches } from "react-router-dom";

import { HelpWidget } from "@/features/help/components/HelpWidget";
import { cn } from "@/lib/utils";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

interface RouteHandle {
  fullbleed?: boolean;
  /**
   * ``flush`` (M8 / chat direto): zera TODO o padding do ``main`` e o
   * ``max-w``/``mx-auto`` do wrapper interno -- a pagina ocupa 100% do
   * espaco util, encostando no sidebar global e na borda inferior. Usado
   * por telas que ja tem seu proprio layout de paineis (ex.: /chat com
   * sidebar de historico + side panel).
   */
  flush?: boolean;
}

export function AppShell() {
  const matches = useMatches();
  const fullbleed = matches.some(
    (m) => (m.handle as RouteHandle | undefined)?.fullbleed === true,
  );
  const flush = matches.some(
    (m) => (m.handle as RouteHandle | undefined)?.flush === true,
  );

  return (
    <div className="flex h-screen w-full overflow-hidden bg-canvas">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar />
        <main
          className={cn(
            "scrollbar-clean flex-1",
            flush
              ? "overflow-hidden"
              : fullbleed
                ? "overflow-hidden px-3 py-3 sm:px-6 lg:px-10 2xl:px-14"
                : "overflow-y-auto px-3 pb-10 pt-4 sm:px-6 sm:pb-16 sm:pt-6 lg:px-10 2xl:px-14",
          )}
        >
          <div
            className={cn(
              flush
                ? "flex h-full min-h-0 w-full min-w-0 flex-col"
                : "mx-auto w-full min-w-0 max-w-[1920px]",
              !flush && fullbleed && "flex h-full min-h-0 flex-col",
            )}
          >
            <Outlet />
          </div>
        </main>
      </div>
      <HelpWidget />
    </div>
  );
}
